import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {User} from 'src/app/shared/models/user.model';
import {SOLICITACAO_AUTORIZACAO} from './autorizacao-api';
import { BusinessService } from './business.service';


@Injectable({providedIn: 'root'})
export class AutenticacaoService {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<User>;
  url: string = SOLICITACAO_AUTORIZACAO;

  constructor(private http: HttpClient,  private businessService: BusinessService) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }


  login(usuario: string, senha: string, meioAcesso: string) {
    var businessId = (this.businessService.getBusinessId()) ? this.businessService.getBusinessId() : '1';
    var body = {
      "usuario": usuario,
      "senha": senha,
      "meioAcesso": meioAcesso,
      "empresa": businessId
    };

    return this.http.post(this.url + '/autenticacao/login', body).pipe(map(user => {
      if (user) {
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.currentUserSubject.next(user);
      }
      return user;
    }));
  }


  publicRecaptcha() {
    return this.http.get(this.url + '/autenticacao/chave_recaptcha')
      .pipe(map(res => res));
  }

  public getAll() {
    return this.http.get(this.url + '/autenticacao/chave_recaptcha').pipe(map(res => res));
  }

  logout() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('selectedTheme');
    localStorage.removeItem('cod_empresa');
    this.currentUserSubject.next(null);
    return (this.businessService.getBusinessId()) ? this.businessService.getBusinessId() : '1';
  }
}
